/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineRatePlanDto
 */
export interface TravelineRatePlanDto {
    /**
     * Rate plan identifier
     * @type {string}
     * @memberof TravelineRatePlanDto
     */
    id: string;
    /**
     * Codes for which corporates clients this rate is allowed
     * @type {Array<string>}
     * @memberof TravelineRatePlanDto
     */
    corporateCodes?: Array<string> | null;
}

/**
 * Check if a given object implements the TravelineRatePlanDto interface.
 */
export function instanceOfTravelineRatePlanDto(value: object): value is TravelineRatePlanDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineRatePlanDtoFromJSON(json: any): TravelineRatePlanDto {
    return TravelineRatePlanDtoFromJSONTyped(json, false);
}

export function TravelineRatePlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRatePlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'corporateCodes': json['corporateCodes'] == null ? undefined : json['corporateCodes'],
    };
}

  export function TravelineRatePlanDtoToJSON(json: any): TravelineRatePlanDto {
      return TravelineRatePlanDtoToJSONTyped(json, false);
  }

  export function TravelineRatePlanDtoToJSONTyped(value?: TravelineRatePlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'corporateCodes': value['corporateCodes'],
    };
}

